import type { RProgram } from '../../../data/program';
import type { KalturaMetaValue } from '../../composed';
import type { KalturaMultilingualStringValue, KalturaProgramAsset } from '../../objects';
import { processPhoenixImages } from '../../processing';

/**
 * @see https://kaltura.atlassian.net/wiki/spaces/XTVEXT/pages/1447559934/Linear+EPG+Ingest#Input-XMLTV-File-Specification
 */
export function processProgram(data: KalturaProgramAsset): RProgram {
  return {
    channelId: data.linearAssetId,
    contentType: parseString(data.metas['ContentType']),
    endDate: data.endDate * 1000,
    episodeName: parseString(data.metas['EpisodeName']),
    externalId: data.externalId,
    genres: parseTag(data.tags['Genre']),
    id: data.id,
    images: processPhoenixImages(data.images),
    imdbId: parseString(data.metas['imdb_id']),
    seasonNumber: parseNumber(data.metas['SeasonNumber']),
    startDate: data.startDate * 1000,
    subtitleLanguages: parseTag(data.tags['SubtitleLanguage']),
    title: data.name,
    type: 'program',
  };
}

function parseNumber(metaValue: KalturaMetaValue | undefined) {
  return metaValue ? Number(metaValue.value) : undefined;
}

function parseString(metaValue: KalturaMetaValue | undefined) {
  return metaValue ? String(metaValue.value) : undefined;
}

function parseTag(tagValue: { objects: KalturaMultilingualStringValue[] } | undefined) {
  return tagValue ? tagValue.objects.map(({ value }) => value) : undefined;
}
